/** legge un cookie (helper rapido) */
export function readCookie(name: string): string | undefined {
	const match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/[$()*+./?[\\\]^{|}-]/g, "\\$&") + "=([^;]*)"));
	return match ? decodeURIComponent(match[1]) : undefined;
}
